import { Alert, Container, Typography } from "@firecms/ui";

import { type AdminToolPageProps } from "./AdminToolPage.types";

const AdminToolPage: React.FC<AdminToolPageProps> = ({ title, description, children }) => {
  return (
    <Container className="flex max-w-3xl flex-col gap-4 p-6">
      <Typography variant="h4">{title}</Typography>

      <Alert color="info">
        <Typography variant="body2">{description}</Typography>
      </Alert>

      {children}
    </Container>
  );
};

export default AdminToolPage;
